import { isEmpty } from "lodash";
import { ProjectDisplaySchema } from "projects/constants/ProjectDisplaySchema";
import { IDisplayFieldConfig } from "projects/models";

export const useDisplayFieldByStage = () => {
  const getDisplayFieldConfigByStage = (
    projectStage: string
  ): IDisplayFieldConfig | undefined =>
    ProjectDisplaySchema.find(
      (x: IDisplayFieldConfig) =>
        x?.name?.toLowerCase() ===
        (isEmpty(projectStage) ? "default" : projectStage?.toLowerCase())
    );

  const displayFieldByStage = (
    _fieldCategory: string,
    _fieldName: string,
    _projectStage: string
  ): boolean => {
    return true;
  };

  const displayFieldCategoryByStage = (
    _fieldCategory: string,
    _projectStage: string
  ): boolean => {
    return true;
  };

  return {
    displayFieldByStage,
    displayFieldCategoryByStage,
  };
};
